"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuestionsMetadata = void 0;
var _lodash = _interopRequireDefault(require("lodash.get"));
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useQuestionsMetadata = function () {
  let {
    flag,
    keyPath
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const metadata = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  if (flag) return (0, _lodash.default)(metadata[flag], keyPath);
  return metadata;
};
exports.useQuestionsMetadata = useQuestionsMetadata;